export const applyFormStyles = {
  "& .MuiInputBase-root.MuiOutlinedInput-root ": {
    bgcolor: "white",
    borderRadius: "8px",
  },
};
